// Binary (IEC) standard: 1 KB = 1024 bytes
const BYTES_PER_KB = 1024

// 1 MB = 1024 KB = 1,048,576 bytes (2^20)
export const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB

export const FILE_SIZE_LIMITS = {
  LOGO_IMAGE: 1 * BYTES_PER_MB, // 1MB
  PROMOTIONAL_IMAGE: 600 * BYTES_PER_KB, // 600KB
  MODULE_TEXTURE: 15 * BYTES_PER_KB, // 15KB
  PDF_DOCUMENT: 3 * BYTES_PER_MB, // 3MB
  WYSIWYG_IMAGE: 2 * BYTES_PER_MB, // 2MB
} as const
